// extracted by mini-css-extract-plugin
export default {"section":"StartMenuApp_section__AGjg5","disabled":"StartMenuApp_disabled__vuds6","bold":"StartMenuApp_bold__fkmXh"};